import moment from 'moment';
import _ from 'lodash';

class NominaRequestInputTransformer {
  getName() {
    return 'nomina';
  }

  make(input) {
    const { Complemento = {} } = input;

    if (!Complemento || !Complemento.Nomina) {
      return input;
    }

    let nomina = { ...Complemento.Nomina };

    const { Receptor = {} } = nomina;
    let {
      Emisor: { nomina: EmisorNomina = {} },
      Receptor: { nomina: ReceptorNomina = {} },
    } = input;

    EmisorNomina = EmisorNomina || {};
    ReceptorNomina = ReceptorNomina || {};

    nomina = {
      Version: '1.2',
      ...nomina,
      FechaPago: moment(nomina.FechaPago).format('YYYY-MM-DD'),
      FechaInicialPago: moment(nomina.FechaInicialPago).format('YYYY-MM-DD'),
      FechaFinalPago: moment(nomina.FechaFinalPago).format('YYYY-MM-DD'),
      Receptor: {
        ...Receptor,
        ...ReceptorNomina,
        Antigüedad: 'P',
        RiesgoPuesto: ReceptorNomina.RiesgoPuesto
          ? parseInt(ReceptorNomina.RiesgoPuesto).toString()
          : parseInt(Receptor.RiesgoPuesto).toString(),
      },
      Emisor: {
        ...EmisorNomina,
      },
    };

    nomina.Receptor['Antigüedad'] = this._calculateAntiguedad(input, nomina);

    input = this._calculateConceptos(input, nomina);
    input = this._calculateTotales(input, nomina);

    input.Complemento = {
      ...input.Complemento,
      Nomina: nomina,
    };

    return input;
  }

  _calculateAntiguedad(input, nomina) {
    let start = moment(nomina.Receptor.FechaInicioRelLaboral || new Date());
    let end = moment(nomina.FechaFinalPago);

    const years = end.diff(start, 'years');

    const months = end.diff(start.add(years, 'years'), 'months');

    const days = end.diff(start.add(months, 'months'), 'days');

    let expression = 'P';

    if (years > 0) {
      expression += `${years}Y`;
    }

    if (months > 0) {
      expression += `${months}M`;
    }

    expression += `${days}D`;

    return expression;
  }

  _calculateConceptos(input, nomina) {
    const concepto = [
      {
        ClaveProdServ: '84111505',
        Cantidad: '1',
        ClaveUnidad: 'ACT',
        Descripcion: 'Pago de nómina',
        ValorUnitario: parseFloat(nomina.TotalPercepciones || 0) + parseFloat(nomina.TotalOtrosPagos || 0),
        Importe: parseFloat(nomina.TotalPercepciones || 0) + parseFloat(nomina.TotalOtrosPagos || 0),
        Descuento: parseFloat(nomina.TotalDeducciones || 0),
      },
    ];

    input = {
      ...input,
      Conceptos: {
        ...input.Conceptos,
        Concepto: concepto,
      },
    };

    return input;
  }

  _calculateTotales(input, nomina) {
    input.SubTotal = parseFloat(nomina.TotalPercepciones || 0) + parseFloat(nomina.TotalOtrosPagos || 0);
    input.Descuento = parseFloat(nomina.TotalDeducciones || 0);
    input.Total = _.round(input.SubTotal - input.Descuento, 2);

    return input;
  }
}

export default NominaRequestInputTransformer;
